
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'

/**
 * ページリンクボタン
 */
@Component({
  components: {
    ButtonBase,
    ImageBase,
  },
})
export default class PageLinkButton extends Vue {
  /** ページ数 */
  @Prop()
  private pageLength!: number

  /** 現在のページ */
  @Prop()
  private currentPage!: number

  /** ページリンクボタン押下時のイベント */
  @Prop()
  private linkClick!: (value: number) => void

  /** 現在ページ前後に表示するページの数 */
  @Prop({ default: 2 })
  private displayRange!: number

  /**
   * ページが1ページ目か判定
   *
   * @returns 1ページ目ならtrue
   */
  private get isMin(): boolean {
    return this.currentPage === 1
  }

  /**
   * ページが最後のページか判定
   *
   * @returns 最後のページならtrue
   */
  private get isMax(): boolean {
    return this.currentPage >= this.pageLength
  }

  /**
   * 表示するページ番号の範囲
   *
   * @returns ページ番号の配列
   */
  private get displayPages(): number[] {
    const pages = []

    // 表示対象範囲でループ
    for (let i = this.pageBegin; i <= this.pageEnd; i++) {
      pages.push(i)
    }

    return pages
  }

  /**
   * ページ一覧の前部分が省略されているか否か
   *
   * @returns 省略時true
   */
  private get isHidePrevPages(): boolean {
    return this.pageBegin !== 1
  }

  /**
   * ページ一覧の後部分が省略されているか否か
   *
   * @returns 省略時true
   */
  private get isHideNextPages(): boolean {
    return this.pageEnd < this.pageLength
  }

  /**
   * 表示するページ番号の最小値
   *
   * @returns ページ番号
   */
  private get pageBegin(): number {
    // ページ数を計算
    let page = this.currentPage - this.displayRange
    // 1未満になる場合は1に固定する
    if (page < 1) {
      page = 1
    }
    return page
  }

  /**
   * 表示するページ番号の最大値
   *
   * @returns ページ番号
   */
  private get pageEnd(): number {
    // ページ数を計算
    let page = this.currentPage + this.displayRange
    // 最終ページを超過する場合は最終ページに固定する
    if (page > this.pageLength) {
      page = this.pageLength
    }
    // 現在ページが最終ページ以降の場合は最終ページで固定する(存在しないページ指定時の処理)
    if (this.currentPage > this.pageLength) {
      page = this.currentPage
    }
    return page
  }

  /**
   * 選択中ページの判定
   *
   * @param number ページ数
   * @returns 一致したらtrue
   */
  private isCurrentPage(number: number): boolean {
    return this.currentPage === number
  }

  /**
   * 指定ページへの移動処理
   */
  private pageJump(): void {
    const page = prompt(`移動するページ番号を半角数字で入力してください。\n範囲:1〜${this.pageLength}`)

    // 未入力の場合は終了
    if (!page) {
      return
    }

    // 入力値を数値に変換し、指定不正時はメッセージを表示し終了
    const pageNum = parseInt(page)
    if (!pageNum || pageNum < 1 || pageNum > this.pageLength) {
      alert('ページ指定が不正です。')
      return
    }

    // ページ遷移イベントを実行
    this.linkClick(pageNum)
  }
}
